import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialFloatOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {z} from "zod/v4-mini"

export interface ValueSockets extends MaterialNodeSockets {
    inputs: {}
    settings: {
        value: "float" // found in inputs: -; found in settings: float; inferred from data: float
    }
    outputs: {
        value: "float"
    }
}

export const valueDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeValue,
    },
    nodeClass: "Value",
    ui: {
        label: "Value",
        color: "#9e3500",
        items: [{name: "value", valueType: "float", label: "Value", defaultValue: 0, input: false, setting: true, output: true}],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({value: materialFloatOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({}),
            settings: z.strictObject({value: z.optional(z.number())}),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<ValueSockets>
